import { Box } from "@mui/material"
import { AppFormGrid, AppFormSection } from "@components"
import React from "react"
import {
	ReportDateRangeExecutionField,
	ReportEmailField,
	ReportFrequencyDaysField,
	ReportFrequencyHoursField,
	ReportManualExecutionSwitch
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"

export default function ReportFormDrawerFrequencySection() {
	return <AppFormSection icon="circle-play" title="Frequency & Notification">
		<AppFormGrid>
			<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-email">
				<ReportEmailField/>
			</Box>
			<Box sx={{ gridColumn: 'span 5' }} data-tour-id="tour-exec-frequency">
				<ReportFrequencyHoursField/>
			</Box>
			<Box sx={{ gridColumn: 'span 5' }} data-tour-id="tour-frequencies">
				<ReportFrequencyDaysField/>
			</Box>
			<Box sx={{ gridColumn: '1 / -1' }}>
				<ReportManualExecutionSwitch/>
			</Box>
			<Box sx={{ gridColumn: '1 / -1' }}>
				<ReportDateRangeExecutionField/>
			</Box>
		</AppFormGrid>
	</AppFormSection>
}
